export { billingHalLinkHref as mollieLinkHref } from "../../../../hal-link-href.ts";
